import {
  IFieldsData,
  IPaymentFields,
  IShipwallet,
  ISteps,
  RootState
} from '@checkout/state';
import { IStepDataModel } from '@checkout/steps';
import { Form, Formik, FormikActions, InjectedFormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
// import { isPaypal } from '../../../utils/paymentMethods';
import { FormikErrorFocus, FormikPersist } from '..';
import { changeStepRequest, checkoutRequest, saveFormValues } from '../../../reducers/checkout';
import * as Styles from './CheckoutForm.scss';

interface IOwnProps {
  stepsList?: IStepDataModel[];
  children: React.ReactNode;
}

interface IFormValues extends IFieldsData {}

interface IConnectedProps {
  steps: ISteps;
  paymentFields: IPaymentFields;
  selectedPaymentMethod: string;
  fieldsData: IFieldsData;
  shipwallet: IShipwallet;
}

interface IConnectetDispatchProps {
  changeStepRequest: typeof changeStepRequest;
  checkoutRequest: typeof checkoutRequest;
  saveFormValues: typeof saveFormValues;
}

type Props = IOwnProps & IConnectetDispatchProps & IConnectedProps & InjectedFormikProps<IOwnProps, IFormValues>;

class CheckoutForm extends React.Component<Props, {}> {

  handleFormSave = (values: IFormValues) => {
    this.props.saveFormValues({ fieldsData: values });
  }

  handleNextStep = () => {
    this.props.changeStepRequest({ step:  this.props.steps.current + 1 });
  }

  onSubmit = (values: IFormValues, actions: FormikActions<IFormValues>) => {
    const { steps, stepsList } = this.props;
    const isLastStep = stepsList && stepsList.length === steps.current;

    if (stepsList) { // Steps checkout case
      if (isLastStep) { this.props.checkoutRequest(); } else { this.handleNextStep(); }
    } else { // Flat checkout case
      this.props.checkoutRequest();
    }
    actions.setTouched({});
    actions.setSubmitting(false);
  }

  render() {
    const { children, fieldsData } = this.props;

    return (
      <Formik<IFormValues, {}>
        initialValues={{ ...fieldsData }}
        // validate={this.validate}
        // enableReinitialize={true}
        onSubmit={this.onSubmit}
        render={(formik) => {

          const childrenWithProps = React.Children.map(children, (child: React.ReactElement<any>) =>
            React.cloneElement(child, { isValid: Object.keys(formik.errors).length === 0 }));

          return (
            <Form className={Styles.form}>
              {childrenWithProps}
              <FormikErrorFocus formikContext={formik} />
              <FormikPersist fieldsDataValues={fieldsData} handlePersist={this.handleFormSave} formikContext={formik} />
            </Form>
          );
        }}
      />
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  connect<IConnectedProps,  IConnectetDispatchProps>(
    (state: RootState) => ({
      steps:  state.checkout.steps,
      paymentFields: state.checkout.paymentFields,
      shipwallet: state.checkout.selection.shipwallet,
      selectedPaymentMethod: state.checkout.selection.paymentMethod,
      fieldsData: state.checkout.fieldsData,
    }),
    {
      changeStepRequest,
      checkoutRequest,
      saveFormValues
    },
  )
)(CheckoutForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/CheckoutForm/CheckoutForm.tsx